<template>
  <div>
    <el-select
      v-if="type=='select'"
      :value="selected"
      style="width: 100%"
      placeholder="请选择信息"
      :clearable="clearable"
      filterable
      class="select-option_table"
      @change="selectChange"
    >
      <el-option
        v-for="(item,index) in infoList"
        :key="index"
        :label="item.label"
        :value="item.value"
        class="select-option_li"
      >

      </el-option>
    </el-select>
  </div>

</template>

<script>
  import {dict} from "@/api";
  import * as constants from '@/constants/index'

  export default {
    name: 'Select',
    model: {
      prop: 'selected',
      event: 'parent-event',
    },
    props: {
      selected:'',
      dictCode: {
        required: true,
        type: String
      },
      type: {
        required: false,
        type: String,
        default: 'select'
      },
      isConstants: {
        required: false,
        type: Boolean,
        default: false
      },
      clearable: {
        required: false,
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        infoList: [],
      }
    },
    created() {
      if(!this.isConstants) {
        this.getSelect()
      } else {
        this.infoList = constants[this.dictCode]
      }
    },
    methods: {
      getSelect() {
        setTimeout(()=>{
          dict(this.dictCode).then(res => {
            for (var item in res.data[this.dictCode]) {
              this.infoList.push({label: item,value: item})
            }
          })
        },300)
      },
      selectChange(val) {
        this.$emit('parent-event', val)
        this.$emit(
          'change',
          this.infoList.find(item => item.name === val)
        )
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/DictSelect/index.vue